module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "title-no"
  }, [_vm._v("201")]), _c('br'), _c('span', {
    staticClass: "org"
  }, [_vm._v("O")]), _c('span', {
    staticClass: "ltgrn"
  }, [_vm._v("r")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("g")]), _c('span', {
    staticClass: "grn"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "org"
  }, [_vm._v("n")]), _c('span', {
    staticClass: "drkgrn"
  }, [_vm._v("i")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("c")]), _vm._v(" "), _c('span', {
    staticClass: "grn"
  }, [_vm._v("B")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "org"
  }, [_vm._v("b")]), _c('span', {
    staticClass: "ltgrn"
  }, [_vm._v("y")]), _c('br'), _c('span', {
    staticClass: "title1"
  }, [_vm._v("AND")]), _c('br'), _c('span', {
    staticClass: "ltgrn"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "org"
  }, [_vm._v("o")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("d")]), _c('span', {
    staticClass: "drkgrn"
  }, [_vm._v("d")]), _c('span', {
    staticClass: "org"
  }, [_vm._v("l")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "ltgrn"
  }, [_vm._v("r")]), _vm._v(" "), _c('span', {
    staticClass: "org"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "ltgrn"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "yellow"
  }, [_vm._v("a")]), _c('span', {
    staticClass: "org"
  }, [_vm._v("l")]), _c('span', {
    staticClass: "drkgrn"
  }, [_vm._v("s")])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("The Healthiest Toddler and Baby Food Recipes You Can Make!")]), _vm._v(" "), _c('h2', {
    staticClass: "author"
  }, [_vm._v("TAMIKA L. GARDNER, "), _c('span', {
    staticClass: "light"
  }, [_vm._v("author of "), _c('i', [_vm._v("201 Organic Baby Purées")])])]), _vm._v(" "), _c('p', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/logo.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_vm._v("AVON, MASSACHUSETTS")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3295799a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Title.vue
// module id = 63
// module chunks = 0